// extracted by mini-css-extract-plugin
export default {"text":"Texts_text__3K41e","strong":"Texts_strong__ZUw0o"};